export const SET_LAYERS = 'SET_LAYERS';
export const CLEAR_LAYERS = 'CLEAR_LAYERS';

export const clearLayers = {
  type: CLEAR_LAYERS,
}

export const setLayers = (data) => {
  return {
    type: SET_LAYERS,
    payload: data,
  }
}